import { createAction, props } from '@ngrx/store';
import { ILegalEntitiesCreateBusinessRequest } from '../../todos/models/create-business.model';

export const loadAddSubLegalEntity = createAction(
  '[AddSubLegalEntity] Load AddSubLegalEntity',
  props<{
    request: ILegalEntitiesCreateBusinessRequest;
    businessId: string;
  }>()
);

export const loadAddSubLegalEntitySuccess = createAction(
  '[AddSubLegalEntity] Load AddSubLegalEntity Success',
  props<{ response: string }>()
);

export const loadAddSubLegalEntityFailure = createAction(
  '[AddSubLegalEntity] Load AddSubLegalEntity Failure',
  props<{ error: Error | any }>()
);
